/*
  Skin Clique: keeps the custom.sale_price markdown on the product page, quick shop and sticky
  add to cart bar after a variant change.

  Stiletto's updatePrices() rewrites [data-price] and [data-compare-price] with the variant's
  regular price on every option change. snippets/product-block-header.liquid prints a
  [data-sc-sale-prices] JSON map (variant id to formatted regular and sale price) when the
  product has a valid markdown. This script watches the price nodes and, whenever they show the
  selected variant's regular price, swaps in the sale price and strikes the regular price.

  Loaded once per page from snippets/quick-view-modal.liquid, which layout/theme.liquid renders on
  every page. It cannot live in the quick shop markup itself: that HTML is injected with innerHTML,
  so its script tags never run. The guard below stops a second copy from binding twice.
*/
(function () {
  if (window.scSalePriceLoaded) return;
  window.scSalePriceLoaded = true;

  function readPrices(jsonEl) {
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function applyScope(jsonEl) {
    var scope = jsonEl.closest('[data-section-type]') || document;
    var prices = readPrices(jsonEl);
    var select = scope.querySelector('[data-variant-select]');
    if (!prices || !select) return;

    var entry = prices[select.value];
    if (!entry) return;

    scope.querySelectorAll('[data-price]').forEach(function (priceEl) {
      // Only rewrite what the theme just wrote: the variant's regular price. Sold-out or
      // custom price labels, and our own sale price, are left alone.
      if (priceEl.textContent.trim() !== entry.regular) return;

      priceEl.innerHTML = entry.sale;
      var compareEl = priceEl.parentNode.querySelector('[data-compare-price]');
      if (compareEl) compareEl.innerHTML = entry.regular;
    });
  }

  function bindScope(jsonEl) {
    if (jsonEl.hasAttribute('data-sc-bound')) return;
    jsonEl.setAttribute('data-sc-bound', '');

    var scope = jsonEl.closest('[data-section-type]') || document;
    var observer = new MutationObserver(function () {
      applyScope(jsonEl);
    });
    scope.querySelectorAll('[data-price]').forEach(function (priceEl) {
      observer.observe(priceEl, { childList: true, characterData: true, subtree: true });
    });

    applyScope(jsonEl);
  }

  function bindAll() {
    document.querySelectorAll('script[data-sc-sale-prices]').forEach(bindScope);
  }

  // Quick shop content arrives after load, already rendered with the right price for its first
  // variant. A capture listener sees every change event, including the non-bubbling one the
  // theme dispatches on the product form, so the quick shop is bound on its first variant change.
  document.addEventListener(
    'change',
    function () {
      window.setTimeout(bindAll, 0);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
})();
